import { RewardLevel } from 'core/enums/rewards-levels';

export const REWARD_LEVELS = [
  {
    image: 'rewards/star-levels/starter.svg',
    name: RewardLevel.Starter,
    points: '0-33',
    tier: 1,
    minPoints: 0,
    maxPoints: 33,
    color: 'rgba(0, 149, 218, 1)',
  },
  {
    image: 'rewards/star-levels/rising-star.svg',
    name: RewardLevel.Rising,
    points: '34-63',
    tier: 2,
    minPoints: 34,
    maxPoints: 63,
    color: 'rgba(184, 198, 205, 1)',
  },
  {
    image: 'rewards/star-levels/super-star.svg',
    name: RewardLevel.Super,
    points: '64-93',
    tier: 3,
    minPoints: 64,
    maxPoints: 93,
    color: 'rgba(255, 173, 20, 1)',
  },
  {
    image: 'rewards/star-levels/legend.svg',
    name: RewardLevel.Legend,
    points: '94+',
    tier: 4,
    minPoints: 93,
    maxPoints: null,
    color: 'rgba(138, 138, 138, 1)',
  },
];